/**
 *
 * @example
 *
 *  let close = new SimpleObservable();
 *  close.register((input) => (console.log("Func 1", input)));
 *  close.register((input) => (console.log("Func 2", input)));
 *  close.register((input) => (console.log("Func 3", input)));
 *  close.notify("has been notified");
 *
 * @return {{}}
 */
function SimpleObservable() {
  let observers = [];
  let scope = {};
  scope.register = function (observer) {
    observers.push(observer);
  };
  scope.notify = function (input) {
    observers.forEach((ob) => ob.call({}, input));
  };

  return scope;
}

export const close = new SimpleObservable();
